import Svg, { Path, Rect } from "react-native-svg";
import { YStack, type YStackProps } from "tamagui";

import { useIsDarkTheme } from "@/theme/helpers";

export const ZocdocLogo = ({
  width = 170,
  ...props
}: { width?: number } & YStackProps) => {
  const isDark = useIsDarkTheme();
  const textFill = isDark ? "#fdfaee" : "#333333";
  return (
    <YStack pointerEvents="none" {...props}>
      <Svg viewBox="0 0 246.26 37.59" width={width} height={width * (26 / 170)}>
        <Rect
          fill="#fff200"
          x={143.78}
          width={102.47}
          height={37.59}
          rx={0.83}
          ry={0.83}
        />
        <Path
          fill="#333333"
          d="M173.99,25.06c-1.67,0-2.99-1.39-2.99-3.13s1.32-3.13,2.99-3.13,3.06,1.39,3.06,3.13c-.07,1.74-1.39,3.13-3.06,3.13ZM173.99,15.45c-3.55,0-6.47,2.92-6.47,6.47s2.92,6.47,6.47,6.47,6.47-2.92,6.47-6.47-2.92-6.47-6.47-6.47Z"
        />
        <Path
          fill="#333333"
          d="M202.04,25.2c-1.81,0-3.2-1.39-3.2-3.27s1.39-3.2,3.2-3.2,3.06,1.39,3.06,3.2c.07,1.81-1.32,3.27-3.06,3.27ZM205.04,16.84c-.9-.84-2.16-1.32-3.62-1.32-2.99,0-6.06,2.23-6.06,6.47,0,2.51,1.11,4.04,2.02,4.87,1.11.97,2.58,1.6,4.04,1.6s2.78-.56,3.62-1.53v1.25h3.55V9.4h-3.55v7.45Z"
        />
        <Path
          fill="#333333"
          d="M216.87,25.06c-1.67,0-2.99-1.39-2.99-3.13s1.32-3.13,2.99-3.13,3.06,1.39,3.06,3.13-1.39,3.13-3.06,3.13ZM216.87,15.45c-3.55,0-6.47,2.92-6.47,6.47s2.92,6.47,6.47,6.47,6.47-2.92,6.47-6.47-2.85-6.47-6.47-6.47Z"
        />
        <Path
          fill="#333333"
          d="M188.4,25.06c-1.74,0-3.06-1.39-3.06-3.13s1.32-3.13,3.06-3.13c1.11,0,2.09.56,2.65,1.53l2.92-1.81c-1.18-1.95-3.2-3.06-5.57-3.06-3.55,0-6.47,2.92-6.47,6.47s2.92,6.47,6.47,6.47c2.37,0,4.45-1.18,5.57-3.06l-2.92-1.81c-.56.97-1.53,1.53-2.65,1.53Z"
        />
        <Path
          fill="#333333"
          d="M231.28,25.06c-1.74,0-3.06-1.39-3.06-3.13s1.32-3.13,3.06-3.13c1.11,0,2.09.56,2.65,1.53l2.92-1.81c-1.18-1.95-3.2-3.06-5.57-3.06-3.55,0-6.47,2.92-6.47,6.47s2.92,6.47,6.47,6.47c2.37,0,4.46-1.18,5.57-3.06l-2.92-1.81c-.56.97-1.53,1.53-2.65,1.53Z"
        />
        <Path
          fill="#333333"
          d="M153.32,25.2c-.07.14-.14.28-.14.42v2.58h13.23v-3.48h-8.42l8.28-12.32c.07-.14.14-.28.14-.42v-2.58h-13.23v3.48h8.49l-8.35,12.32Z"
        />
        <Path
          fill={textFill}
          d="M0,11.41h6.53c3.59,0,6.11,2.6,6.11,5.93s-2.53,5.93-6.16,5.93h-3.98v4.92H0V11.41ZM2.51,13.71v7.24h3.81c2.34,0,3.82-1.56,3.82-3.61s-1.47-3.63-3.82-3.63h-3.81Z"
        />
        <Path
          fill={textFill}
          d="M14.37,21.98c0-3.58,2.87-6.46,6.46-6.46s6.46,2.87,6.46,6.46-2.87,6.46-6.46,6.46-6.46-2.87-6.46-6.46ZM24.82,21.98c0-2.3-1.77-4.14-4-4.14s-3.98,1.84-3.98,4.14,1.72,4.14,3.98,4.14,4-1.84,4-4.14Z"
        />
        <Path
          fill={textFill}
          d="M28.32,15.78h2.55l2.9,9.03,3.38-9.03h2.41l3.33,9.03,2.99-9.03h2.55l-4.32,12.41h-2.37l-3.42-9.1-3.45,9.1h-2.44l-4.11-12.41Z"
        />
        <Path
          fill={textFill}
          d="M49.47,22.03c0-3.65,2.8-6.5,6.46-6.5s6.37,2.67,6.37,6.34v1.03h-10.43c.37,2,1.93,3.33,4.21,3.33,1.75,0,2.9-.8,3.63-2l2.05,1.22c-1.19,1.79-2.99,2.99-5.68,2.99-3.95,0-6.6-2.8-6.6-6.41ZM51.95,20.79h7.84c-.37-1.95-1.82-3.08-3.86-3.08s-3.49,1.29-3.98,3.08Z"
        />
        <Path
          fill={textFill}
          d="M64.81,15.78h2.44v2.16c.53-1.56,1.79-2.34,3.38-2.34.85,0,1.61.18,2.09.48l-.97,2.39c-.35-.23-.85-.37-1.56-.37-1.77,0-2.9.87-2.9,3.1v6.99h-2.48v-12.41Z"
        />
        <Path
          fill={textFill}
          d="M73.17,22.03c0-3.65,2.8-6.5,6.46-6.5s6.37,2.67,6.37,6.34v1.03h-10.43c.37,2,1.93,3.33,4.21,3.33,1.75,0,2.9-.8,3.63-2l2.05,1.22c-1.19,1.79-2.99,2.99-5.68,2.99-3.95,0-6.6-2.8-6.6-6.41ZM75.66,20.79h7.84c-.37-1.95-1.82-3.08-3.86-3.08s-3.49,1.29-3.98,3.08Z"
        />
        <Path
          fill={textFill}
          d="M88.07,21.98c0-3.91,2.92-6.46,6.25-6.46,1.65,0,3.29.76,4.23,1.98v-7.47h2.44v18.16h-2.44v-1.82c-.97,1.29-2.6,2.07-4.25,2.07-3.24,0-6.23-2.57-6.23-6.46ZM98.69,21.96c0-2.3-1.72-4.18-4.07-4.18s-4.09,1.84-4.09,4.18,1.79,4.21,4.09,4.21,4.07-1.88,4.07-4.21Z"
        />
        <Path
          fill={textFill}
          d="M112.02,26.39v1.79h-2.44V10.03h2.46v7.54c.94-1.26,2.57-2.04,4.25-2.04,3.29,0,6.21,2.55,6.21,6.46s-2.96,6.46-6.18,6.46c-1.7,0-3.36-.76-4.3-2.05ZM120.02,21.96c0-2.34-1.77-4.18-4.05-4.18s-4.09,1.89-4.09,4.18,1.77,4.21,4.09,4.21,4.05-1.86,4.05-4.21Z"
        />
        <Path
          fill={textFill}
          d="M122.23,31.79l1.47-2.09c.44.44.94.71,1.66.71,1.29,0,1.95-.53,2.76-2.3l.23-.53-5.1-11.81h2.67l3.72,8.89,3.56-8.89h2.64l-5.54,13.03c-1.24,2.94-2.53,3.98-4.92,3.98-1.17,0-2.34-.39-3.15-.99Z"
        />
      </Svg>
    </YStack>
  );
};
